// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2780%27 height=%2780%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23000000%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Box Model Hack */
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

/* Clear fix hack */
.clearfix:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
}

.clear {
   clear: both;
}

/* Global button reset  */
button {
    appearance: none;          
    -webkit-appearance: none;  
    -moz-appearance: none;     

    border: none;              
    padding: 0;                
    margin: 0;                 

    background: none;          
    font: inherit;             
    color: inherit;            
    line-height: inherit;      

    text-align: inherit;       
    cursor: pointer;           
}
/******************************************
/* BASE STYLES
/*******************************************/
* {
    font-family: "Rubik";
}

a {
    text-decoration: none;
    color: var(--text-grey);
}

:root {
    --text-grey: #212121;
    --border: solid 1px #D1D1D1;
}

h1 {
    font-size: 2.5rem;
    color: #3240ff;
}

h2 {
    border-bottom: #212121 solid 2px;
    padding-bottom: 10px;
    align-self: center;
}

p {
    text-align: center;
    padding: 0 15px;

}

/******************************************
/* BASE STYLES
/*******************************************/

body {
    width: 100%;
    height: 100vh;
    padding: 40px 60px;
    background-color: #F5F8FA;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}


body > div {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: 61px 1fr;
    grid-template-columns: 230px 1fr;
    gap: 20px;
}


header {
    grid-column: 1 / 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

header img {
    width: 200px;
}

header a img {
    width: 50px;
}


aside {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: solid 1px #D1D1D1;
    padding-top: 30px;
    position: relative;
}


nav > div:nth-child(1) > button {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 15px;
    border: solid 1px #D1D1D1;
}

aside button img {
    width: 20px;
}

nav {
    width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 60px;
    
}

nav > div {
    display: flex;
    flex-direction: column;
    gap: 23px;
    padding-bottom: 23px;
}

.category-wrapper {
    overflow-y: auto;
    max-height: 350px;
    border-bottom: solid 1px #D1D1D1;
}

.category-wrapper > div:nth-child(1) {
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #D1D1D1;
    padding-bottom: 10px;
    font-size: 1.1;
}

.category-wrapper > div:nth-child(1) {
    position: sticky;
    top: 0;
    background-color: #F5F8FA;
}

.category-wrapper button {
    justify-content: space-between;
}

.category-wrapper button div {
    display: flex;
    align-items: center;
    gap: 10px;
}

aside > div:nth-child(2) {
    position: absolute;
    bottom: 0;
    left: 0;
}

.plus-icon {
    width: 23px;
    aspect-ratio: 1/1;
}


.category-wrapper.displayCategoryError::after {
    position: absolute;
    content: 'You must have at least one category!';
    font-size: 0.8rem;
    top: 350px;
    left: 35px;
    width: 150px;
    background-color: red;
    border-radius: 15px;
    color: white;
    padding: 7px;
    text-align: center;
}

.sidebarBtn {
    background-color: #E8E8E8;
    color: #212121;
}

.sidebarBtn.active {
    background-color: #3240ff;
    color: white;
}


.github-credit {
    display: flex;
    align-items: center;
    gap: 8px;
}

.github-credit img {
    width: 20px;
}

.userCategory div:nth-child(1) {
    pointer-events: none;
}



main {
    width: calc(100%);
    display: flex;
    flex-direction: column;
    gap: 20px;
}

section {
    background-color: white;
    border-radius: 15px;
    border: solid 1px #D1D1D1;
}

.todays-tasks-wrapper:nth-child(1) {
    height: 15%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #e3e5ff;
}

.todays-tasks-wrapper:nth-child(1) div {
    display: flex;
    gap: 10px;
    flex-direction: column;
}

.todays-tasks-wrapper div:nth-child(1) span:nth-child(1) {
    font-size: 2rem;
    font-weight: 600;
}

.todays-tasks-wrapper div:nth-child(1) span:nth-child(2) {
    font-size: 1.2rem;
    font-weight: 300;
}


.todays-tasks-wrapper div:nth-child(2) span {
    font-size: 1.4rem;
    font-weight: 400;
}

.todays-tasks-wrapper div:nth-child(2) span span {
    font-weight: 600;
}


#taskWindow {
   height: 85%; 
   padding: 30px 20px 20px 20px;
   position: relative;
   display: flex;
   justify-content: center;
}

.task-window-wrapper {
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    
    
    
}

.task-window-wrapper > div:nth-child(1) > div{
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: var(--border);
    margin-bottom: 20px;
    
}



.task-window-wrapper div:nth-child(1) i {
    color: #3240ff;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.tasks-wrapper {
    width: 100%;
    overflow: auto;
    height: 50vh;
}

.tasks-wrapper > div:nth-child(1) {
    width: 100%;
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 7px;
    border-bottom: var(--border);
    position: sticky;
    top: 0;
    background-color: white;
}

h3 , h3 span {
    font-size: 1.1rem;
    
    font-weight: 600;
}

.tasks-wrapper > div:nth-child(1) img {
    width: 25px;
    aspect-ratio: 1 / 1;
}

.tasks-wrapper h3 span {
    font-weight: 600; 
}

.individualTaskWrapper {
    width: 100%;
    height: 50px;
    display: flex;
    position: relative;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    
    border-bottom: solid 1px #f0f0f0;
    overflow: auto;
}


.individualTaskWrapper > div:nth-child(1) {
    display: flex;
    align-items: center;
    gap: 8px;
}



.individualTaskWrapper > div:nth-child(2) {
    display: flex;
    align-items: center;
    gap: 12px;
}

.individualTaskWrapper img {
    width: 20px;
}

/* Task bubble */
.individualTaskWrapper > div > div  {
    width: 15px;
    aspect-ratio: 1 / 1;
    border: solid 2px #D1D1D1;
    border-radius: 50%;
}



#taskWindow > button i {
    width: 50px;
    aspect-ratio: 1 / 1;
    position: absolute;
    bottom: 20px;
    right: 31px;
}

#taskWindow > button i {
    font-size: 60px;
}


.modal-wrapper {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: #64646445;
    display: flex;
    justify-content: center;
    align-items: center;
}

.delete {
    padding: 80px 80px 70px 80px ;
}

.cancelDelete {
    background-color: #959595 !important;
}

form {
    min-width: 600px;
    padding: 30px;
    background: rgba(255, 255, 255, 0.901);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: center;
    position: relative;

}

.fa-xmark {
    font-size: 40px;
    aspect-ratio: 1 / 1;
    position: absolute;
    top: 20px;
    right: 22px;
}



.form-question-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

input[type="text"] {
   
   
}

input , textarea , select{
    width: 60%;
    border-radius: 15px;
    padding: 8px;
    border: solid #626262 1px;
}

select {
    appearance: none;
    padding: 0 40px 0 10px; 
    height: 40px;            
    line-height: 40px;        
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 
                no-repeat 
                right 10px 
                center;
  
    background-size: 20px 20px;
    font-size: 16px;
}


input:user-invalid , textarea:user-invalid , select:user-invalid  {
    border: solid #fa3d3d 1px;
}

input:user-valid , textarea:user-valid , option:user-valid {
    border: solid #4ccb63 1px;
}

input:focus , textarea:focus {
    border: solid #3240ff 1px;
}


input[type="checkbox"] {
    width: 15px;
    height: 15px;

}

textarea {
    resize: none;
    height: 70px;
}

label[for="taskImportantStatus"] {
    display: flex;
    align-items: center;
    gap: 10px;
}

.form-btn-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    
}

form button {
        border-radius:6px;
        border:1px solid #3c3c3c;
        display:inline-block;
        cursor:pointer;
        color:#ffffff;
        padding:6px 24px;
        text-decoration:none;
        text-shadow:0px 1px 0px #8c8c8c;
        width: 60%;
}

#createTask , #editTask , #completeTask , #createCategory , #editCategory {
    background-color: #3240ff;
}

button#deleteTask, button#deleteCategory , .cancelBtn {
    background-color: #ff4646;
}

.cancelDelete {
    background-color: #b0b0b0;
}

.errorMessage {
    color: red;
}

.complete::after {
    content: " ";
    position: absolute;
    border-bottom: #3240ff55 solid 2px;
    width: 100%;
    height: 2px;
    top: 22px;
}


/******************************************
/* UTILITY STYLES
/*******************************************/

.button {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;
    background-color: #E8E8E8;
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 15px;
    border: solid 1px #D1D1D1;
}


.task-window-wrapper .fa-eye ,.task-window-wrapper .fa-pen-to-square , .task-window-wrapper .fa-trash {
    color: #212121;
}

.big-black {
    width: 100vw;
    height: 100vh;
    background-color: black;
    position: absolute;
}

.small-white {
    width: 50vw;
    height: 50vh;
    background-color: white;
}

.task-window-wrapper div:nth-child(1) i {
    font-size: 35px;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;GACG,WAAW;AACd;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;;IAErB,YAAY;IACZ,UAAU;IACV,SAAS;;IAET,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,oBAAoB;;IAEpB,mBAAmB;IACnB,eAAe;AACnB;AACA;;4CAE4C;AAC5C;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;;4CAE4C;;AAE5C;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,gCAAgC;IAChC,SAAS;AACb;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;;;AAIA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;GACG,WAAW;GACX,4BAA4B;GAC5B,kBAAkB;GAClB,aAAa;GACb,uBAAuB;AAC1B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;;;;AAIb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;IAC5B,mBAAmB;;AAEvB;;;;AAIA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,MAAM;IACN,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;;IAEnB,gCAAgC;IAChC,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;;;AAIA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,yCAAyC;IACzC,0BAA0B;IAC1B,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;;AAGA;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB;;;sBAGkB;;IAElB,0BAA0B;IAC1B,eAAe;AACnB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;;AAEb;;AAEA;QACQ,iBAAiB;QACjB,wBAAwB;QACxB,oBAAoB;QACpB,cAAc;QACd,aAAa;QACb,gBAAgB;QAChB,oBAAoB;QACpB,+BAA+B;QAC/B,UAAU;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,WAAW;IACX,SAAS;AACb;;;AAGA;;4CAE4C;;AAE5C;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* Box Model Hack */\n* {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n}\n\n/* Clear fix hack */\n.clearfix:after {\n    content: \".\";\n    display: block;\n    clear: both;\n    visibility: hidden;\n    line-height: 0;\n    height: 0;\n}\n\n.clear {\n   clear: both;\n}\n\n/* Global button reset  */\nbutton {\n    appearance: none;          \n    -webkit-appearance: none;  \n    -moz-appearance: none;     \n\n    border: none;              \n    padding: 0;                \n    margin: 0;                 \n\n    background: none;          \n    font: inherit;             \n    color: inherit;            \n    line-height: inherit;      \n\n    text-align: inherit;       \n    cursor: pointer;           \n}\n/******************************************\n/* BASE STYLES\n/*******************************************/\n* {\n    font-family: \"Rubik\";\n}\n\na {\n    text-decoration: none;\n    color: var(--text-grey);\n}\n\n:root {\n    --text-grey: #212121;\n    --border: solid 1px #D1D1D1;\n}\n\nh1 {\n    font-size: 2.5rem;\n    color: #3240ff;\n}\n\nh2 {\n    border-bottom: #212121 solid 2px;\n    padding-bottom: 10px;\n    align-self: center;\n}\n\np {\n    text-align: center;\n    padding: 0 15px;\n\n}\n\n/******************************************\n/* BASE STYLES\n/*******************************************/\n\nbody {\n    width: 100%;\n    height: 100vh;\n    padding: 40px 60px;\n    background-color: #F5F8FA;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\nbody > div {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    grid-template-rows: 61px 1fr;\n    grid-template-columns: 230px 1fr;\n    gap: 20px;\n}\n\n\nheader {\n    grid-column: 1 / 3;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\nheader img {\n    width: 200px;\n}\n\nheader a img {\n    width: 50px;\n}\n\n\naside {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-top: solid 1px #D1D1D1;\n    padding-top: 30px;\n    position: relative;\n}\n\n\nnav > div:nth-child(1) > button {\n    width: 100%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 15px;\n    border: solid 1px #D1D1D1;\n}\n\naside button img {\n    width: 20px;\n}\n\nnav {\n    width: 100%;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 60px;\n    \n}\n\nnav > div {\n    display: flex;\n    flex-direction: column;\n    gap: 23px;\n    padding-bottom: 23px;\n}\n\n.category-wrapper {\n    overflow-y: auto;\n    max-height: 350px;\n    border-bottom: solid 1px #D1D1D1;\n}\n\n.category-wrapper > div:nth-child(1) {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: solid 1px #D1D1D1;\n    padding-bottom: 10px;\n    font-size: 1.1;\n}\n\n.category-wrapper > div:nth-child(1) {\n    position: sticky;\n    top: 0;\n    background-color: #F5F8FA;\n}\n\n.category-wrapper button {\n    justify-content: space-between;\n}\n\n.category-wrapper button div {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\naside > div:nth-child(2) {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\n\n.plus-icon {\n    width: 23px;\n    aspect-ratio: 1/1;\n}\n\n\n.category-wrapper.displayCategoryError::after {\n    position: absolute;\n    content: 'You must have at least one category!';\n    font-size: 0.8rem;\n    top: 350px;\n    left: 35px;\n    width: 150px;\n    background-color: red;\n    border-radius: 15px;\n    color: white;\n    padding: 7px;\n    text-align: center;\n}\n\n.sidebarBtn {\n    background-color: #E8E8E8;\n    color: #212121;\n}\n\n.sidebarBtn.active {\n    background-color: #3240ff;\n    color: white;\n}\n\n\n.github-credit {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.github-credit img {\n    width: 20px;\n}\n\n.userCategory div:nth-child(1) {\n    pointer-events: none;\n}\n\n\n\nmain {\n    width: calc(100%);\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\nsection {\n    background-color: white;\n    border-radius: 15px;\n    border: solid 1px #D1D1D1;\n}\n\n.todays-tasks-wrapper:nth-child(1) {\n    height: 15%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    background-color: #e3e5ff;\n}\n\n.todays-tasks-wrapper:nth-child(1) div {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n}\n\n.todays-tasks-wrapper div:nth-child(1) span:nth-child(1) {\n    font-size: 2rem;\n    font-weight: 600;\n}\n\n.todays-tasks-wrapper div:nth-child(1) span:nth-child(2) {\n    font-size: 1.2rem;\n    font-weight: 300;\n}\n\n\n.todays-tasks-wrapper div:nth-child(2) span {\n    font-size: 1.4rem;\n    font-weight: 400;\n}\n\n.todays-tasks-wrapper div:nth-child(2) span span {\n    font-weight: 600;\n}\n\n\n#taskWindow {\n   height: 85%; \n   padding: 30px 20px 20px 20px;\n   position: relative;\n   display: flex;\n   justify-content: center;\n}\n\n.task-window-wrapper {\n    width: 70%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    \n    \n    \n}\n\n.task-window-wrapper > div:nth-child(1) > div{\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 10px;\n    border-bottom: var(--border);\n    margin-bottom: 20px;\n    \n}\n\n\n\n.task-window-wrapper div:nth-child(1) i {\n    color: #3240ff;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.tasks-wrapper {\n    width: 100%;\n    overflow: auto;\n    height: 50vh;\n}\n\n.tasks-wrapper > div:nth-child(1) {\n    width: 100%;\n    display: flex;\n    gap: 20px;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 7px;\n    border-bottom: var(--border);\n    position: sticky;\n    top: 0;\n    background-color: white;\n}\n\nh3 , h3 span {\n    font-size: 1.1rem;\n    \n    font-weight: 600;\n}\n\n.tasks-wrapper > div:nth-child(1) img {\n    width: 25px;\n    aspect-ratio: 1 / 1;\n}\n\n.tasks-wrapper h3 span {\n    font-weight: 600; \n}\n\n.individualTaskWrapper {\n    width: 100%;\n    height: 50px;\n    display: flex;\n    position: relative;\n    gap: 20px;\n    justify-content: space-between;\n    align-items: center;\n    \n    border-bottom: solid 1px #f0f0f0;\n    overflow: auto;\n}\n\n\n.individualTaskWrapper > div:nth-child(1) {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n\n\n.individualTaskWrapper > div:nth-child(2) {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.individualTaskWrapper img {\n    width: 20px;\n}\n\n/* Task bubble */\n.individualTaskWrapper > div > div  {\n    width: 15px;\n    aspect-ratio: 1 / 1;\n    border: solid 2px #D1D1D1;\n    border-radius: 50%;\n}\n\n\n\n#taskWindow > button i {\n    width: 50px;\n    aspect-ratio: 1 / 1;\n    position: absolute;\n    bottom: 20px;\n    right: 31px;\n}\n\n#taskWindow > button i {\n    font-size: 60px;\n}\n\n\n.modal-wrapper {\n    position: absolute;\n    width: 100vw;\n    height: 100vh;\n    background-color: #64646445;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.delete {\n    padding: 80px 80px 70px 80px ;\n}\n\n.cancelDelete {\n    background-color: #959595 !important;\n}\n\nform {\n    min-width: 600px;\n    padding: 30px;\n    background: rgba(255, 255, 255, 0.901);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(5px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n    position: relative;\n\n}\n\n.fa-xmark {\n    font-size: 40px;\n    aspect-ratio: 1 / 1;\n    position: absolute;\n    top: 20px;\n    right: 22px;\n}\n\n\n\n.form-question-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\ninput[type=\"text\"] {\n   \n   \n}\n\ninput , textarea , select{\n    width: 60%;\n    border-radius: 15px;\n    padding: 8px;\n    border: solid #626262 1px;\n}\n\nselect {\n    appearance: none;\n    padding: 0 40px 0 10px; \n    height: 40px;            \n    line-height: 40px;        \n    background: white url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\") \n                no-repeat \n                right 10px \n                center;\n  \n    background-size: 20px 20px;\n    font-size: 16px;\n}\n\n\ninput:user-invalid , textarea:user-invalid , select:user-invalid  {\n    border: solid #fa3d3d 1px;\n}\n\ninput:user-valid , textarea:user-valid , option:user-valid {\n    border: solid #4ccb63 1px;\n}\n\ninput:focus , textarea:focus {\n    border: solid #3240ff 1px;\n}\n\n\ninput[type=\"checkbox\"] {\n    width: 15px;\n    height: 15px;\n\n}\n\ntextarea {\n    resize: none;\n    height: 70px;\n}\n\nlabel[for=\"taskImportantStatus\"] {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.form-btn-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    \n}\n\nform button {\n        border-radius:6px;\n        border:1px solid #3c3c3c;\n        display:inline-block;\n        cursor:pointer;\n        color:#ffffff;\n        padding:6px 24px;\n        text-decoration:none;\n        text-shadow:0px 1px 0px #8c8c8c;\n        width: 60%;\n}\n\n#createTask , #editTask , #completeTask , #createCategory , #editCategory {\n    background-color: #3240ff;\n}\n\nbutton#deleteTask, button#deleteCategory , .cancelBtn {\n    background-color: #ff4646;\n}\n\n.cancelDelete {\n    background-color: #b0b0b0;\n}\n\n.errorMessage {\n    color: red;\n}\n\n.complete::after {\n    content: \" \";\n    position: absolute;\n    border-bottom: #3240ff55 solid 2px;\n    width: 100%;\n    height: 2px;\n    top: 22px;\n}\n\n\n/******************************************\n/* UTILITY STYLES\n/*******************************************/\n\n.button {\n    width: 100%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 10px;\n    background-color: #E8E8E8;\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 15px;\n    border: solid 1px #D1D1D1;\n}\n\n\n.task-window-wrapper .fa-eye ,.task-window-wrapper .fa-pen-to-square , .task-window-wrapper .fa-trash {\n    color: #212121;\n}\n\n.big-black {\n    width: 100vw;\n    height: 100vh;\n    background-color: black;\n    position: absolute;\n}\n\n.small-white {\n    width: 50vw;\n    height: 50vh;\n    background-color: white;\n}\n\n.task-window-wrapper div:nth-child(1) i {\n    font-size: 35px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
